import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { RegisterManualEmailRequest } from "./RegisterManualEmailRequest";
import { ImportPreviewRequest } from "./ImportPreviewRequest";
import { DigitalIDImportPreviewRequest } from "./DigitalIDImportPreviewRequest";
import { CheckValidActivationsRequest } from "./CheckValidActivationsRequest";
import { PrintReportManualRequest } from "./PrintReportManualRequest";

@Injectable()
export class DataService_Student_DigitalID {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	RegisterManualStudentSelectList(SchoolID, GradeLevelID, AcademyID, HomeroomID, GroupID, Active, AlreadyPrinted) {
		var postResult$ = new Subject();
		var url =
			"DigitalID/RegisterManualStudentSelectList?SchoolID=" +
			SchoolID +
			"&GradeLevelID=" +
			GradeLevelID +
			"&AcademyID=" +
			AcademyID +
			"&HomeroomID=" +
			HomeroomID +
			"&GroupID=" +
			GroupID +
			"&Active=" +
			Active +
			"&AlreadyPrinted=" +
			AlreadyPrinted;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RegisterEmail(parms: RegisterManualEmailRequest) {
		var postResult$ = new Subject();
		var url = "DigitalID/RegisterEmail";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	EmailLogInfoSelectList(StartDate, EndDate) {
		var postResult$ = new Subject();
		var url = "DigitalID/StudentEmailLogInfoSelectList?StartDate=" + StartDate + "&EndDate=" + EndDate;
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ExportFormatOptionSelectList() {
		var postResult$ = new Subject();
		var url = "DigitalID/ExportFormatOptionSelectList?";
		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ExportSelectList(SchoolID, GradeLevelID, AcademyID, HomeroomID, GroupID, Active, AlreadyPrinted, FormatOptionID) {
		var postResult$ = new Subject();
		var url =
			"DigitalID/ExportSelectList?SchoolID=" +
			SchoolID +
			"&GradeLevelID=" +
			GradeLevelID +
			"&AcademyID=" +
			AcademyID +
			"&HomeroomID=" +
			HomeroomID +
			"&GroupID=" +
			GroupID +
			"&Active=" +
			Active +
			"&AlreadyPrinted=" +
			AlreadyPrinted +
			"&FormatOptionID=" +
			FormatOptionID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadImportPreviewData(parms: ImportPreviewRequest) {
		var postResult$ = new Subject();
		var url = "DigitalID/StudentLoadImportPreviewData";
		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	LoadImportPreviewAll(parms: DigitalIDImportPreviewRequest) {
		var postResult$ = new Subject();
		var url = "DigitalID/StudentLoadImportPreviewAll";
		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	EmailCheckValidActivations(parms: CheckValidActivationsRequest) {
		var postResult$ = new Subject();
		var url = "DigitalID/EmailCheckValidActivations";
		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	PrintReportManual(parms: PrintReportManualRequest) {
		var postResult$ = new Subject();
		var url = "Report/PrintReportManual";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe(
			(response) => {
				postResult$.next(response);
			},
			(error) => {
				postResult$.error(error);
			}
		);
		return postResult$;
	}
}
